module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (238).e0e8ad6c.jpg";